import React from 'react';
import { Box } from '@mui/material';

interface Props {
    videoId: string;
    title: string;
}

const YouTubeEmbed = ({ videoId, title }: Props) => {
	return (
		<Box
			sx={{
				position: 'relative',
				paddingTop: '56.25%', // Aspect ratio 16:9
				overflow: 'hidden',
				borderRadius: 2, // Rounded corners
				boxShadow: 3, // Material-UI elevation
			}}
		>
			<iframe
				src={`https://www.youtube.com/embed/${videoId}`}
				title={title}
				frameBorder="0"
				allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
				allowFullScreen
				style={{
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
				}}
			></iframe>
		</Box>
	);
};

export default YouTubeEmbed;
